import angular from 'angular';
import moment from 'moment';
import { v4 } from 'uuid';
export default class CrmService {
    $rootScope;
    $q;
    $http;
    AuthenticationService;
    CoreCliente;
    CoreContacto;
    CoreClienteContacto;
    CrmInteracao;
    Funcionario;
    CrmEmpresaAssociada;
    CrmDocumentoAssociado;
    CrmPessoaAssociada;
    CrmCotacao;
    CrmCotacaoEstado;
    CrmLinhaCotacao;
    CoreDepartamento;
    CrmAlteracaoestadoCotacao;
    CrmOportunidade;
    CrmVendedor;
    CoreClienteOi;
    CoreClienteProcesso;
    PRIClientes;
    PRIIEPContactos;
    PRIIEPLinhascontactoentidades;
    PRIIEPCondpag;
    PRICabecdoc;
    PRILinhasdoc;
    CrmProposta;
    CrmCotacaoCancelamento;
    envURL;
    user;
    constructor($rootScope, $q, $http, AuthenticationService, CoreCliente, CoreContacto, CoreClienteContacto, CrmInteracao, Funcionario, CrmEmpresaAssociada, CrmDocumentoAssociado, CrmPessoaAssociada, CrmCotacao, CrmCotacaoEstado, CrmLinhaCotacao, CoreDepartamento, CrmAlteracaoestadoCotacao, CrmOportunidade, CrmVendedor, CoreClienteOi, CoreClienteProcesso, PRIClientes, PRIIEPContactos, PRIIEPLinhascontactoentidades, PRIIEPCondpag, PRICabecdoc, PRILinhasdoc, CrmProposta, CrmCotacaoCancelamento) {
        this.$rootScope = $rootScope;
        this.$q = $q;
        this.$http = $http;
        this.AuthenticationService = AuthenticationService;
        this.CoreCliente = CoreCliente;
        this.CoreContacto = CoreContacto;
        this.CoreClienteContacto = CoreClienteContacto;
        this.CrmInteracao = CrmInteracao;
        this.Funcionario = Funcionario;
        this.CrmEmpresaAssociada = CrmEmpresaAssociada;
        this.CrmDocumentoAssociado = CrmDocumentoAssociado;
        this.CrmPessoaAssociada = CrmPessoaAssociada;
        this.CrmCotacao = CrmCotacao;
        this.CrmCotacaoEstado = CrmCotacaoEstado;
        this.CrmLinhaCotacao = CrmLinhaCotacao;
        this.CoreDepartamento = CoreDepartamento;
        this.CrmAlteracaoestadoCotacao = CrmAlteracaoestadoCotacao;
        this.CrmOportunidade = CrmOportunidade;
        this.CrmVendedor = CrmVendedor;
        this.CoreClienteOi = CoreClienteOi;
        this.CoreClienteProcesso = CoreClienteProcesso;
        this.PRIClientes = PRIClientes;
        this.PRIIEPContactos = PRIIEPContactos;
        this.PRIIEPLinhascontactoentidades = PRIIEPLinhascontactoentidades;
        this.PRIIEPCondpag = PRIIEPCondpag;
        this.PRICabecdoc = PRICabecdoc;
        this.PRILinhasdoc = PRILinhasdoc;
        this.CrmProposta = CrmProposta;
        this.CrmCotacaoCancelamento = CrmCotacaoCancelamento;
        this.user = AuthenticationService.getUser();
        // By default, envURL is production (to account for fails)
        this.envURL = 'https://inspecoeseletricas.pt';
        // Get environment for URL for files
        // Doing this here only because we only use this.envURL in the view
        this.$rootScope.$on('$receivedServerStatus', (evt, data) => {
            if (data != null && data.environment != null) {
                let env = data.environment;
                if (env === 'staging') {
                    this.envURL = 'https://staging-ie.iep.pt';
                }
                else if (env === 'production') {
                    // For completeness
                    this.envURL = 'https://inspecoeseletricas.pt';
                }
                else {
                    this.envURL = 'https://dev-iep-ie.streamline.pt';
                }
            }
        });
    }
    generatePreviewDoc = (id) => {
        return `/api/crmcotacaos/${id}/preview?access_token=${this.AuthenticationService.getToken()}`;
    };
    getUserId() {
        return this.user.id;
    }
    validEmail = email => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };
    generateUUID = () => {
        let uuid = '', i, random;
        for (i = 0; i < 32; i++) {
            random = (Math.random() * 16) | 0;
            if (i == 8 || i == 12 || i == 16 || i == 20) {
                uuid += '-';
            }
            uuid += (i == 12 ? 4 : i == 16 ? (random & 3) | 8 : random).toString(16);
        }
        return uuid;
    };
    // Pessoas
    findPessoaById = (id) => {
        let defer = this.$q.defer();
        this.CoreContacto.findOne({ filter: { where: { id: id } } })
            .$promise.then(data => {
            defer.resolve(data);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    upsertPessoa = (pessoa) => {
        let defer = this.$q.defer();
        pessoa.password = this.generateUUID();
        if (pessoa.clienteId === null) {
            pessoa.clienteId = 1;
        }
        this.CoreContacto.upsert(pessoa)
            .$promise.then(data => {
            defer.resolve(data);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    // Emrpesas
    findEmpresas = () => {
        let defer = this.$q.defer();
        this.CoreCliente.find({ filter: { limit: 100 } })
            .$promise.then(data => {
            defer.resolve(data);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    upsertEmpresa = (empresa) => {
        let defer = this.$q.defer();
        if (empresa.uuid == '') {
            empresa.uuid = this.generateUUID();
        }
        this.CoreCliente.upsert(empresa)
            .$promise.then(data => {
            defer.resolve(data);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    // tabelas
    // save and edit Interação
    upsertInteracao = (dadosInteracao) => {
        let defer = this.$q.defer();
        if (dadosInteracao.observacoes == '') {
            dadosInteracao.observacoes = null;
        }
        this.CrmInteracao.upsert(dadosInteracao)
            .$promise.then(data => {
            defer.resolve(data);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    // save and edit Empresa Associada
    upsertEmpresaAssociada = async (dadosEmp) => {
        let defer = this.$q.defer();
        if (dadosEmp.observacoes == '') {
            dadosEmp.observacoes = null;
        }
        this.CrmEmpresaAssociada.upsert(dadosEmp)
            .$promise.then(data => {
            defer.resolve(data);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    // save and edit Documento Associado
    upsertDoc = (doc, hist) => {
        return this.CrmDocumentoAssociado.upsertDoc({ params: { doc, hist } }).$promise;
    };
    // save and edit Empresa Associada
    upsertPessoaAssociada = async (dados) => {
        let defer = this.$q.defer();
        if (dados.observacoes == '') {
            dados.observacoes = null;
        }
        this.CrmPessoaAssociada.upsert(dados)
            .$promise.then(data => {
            defer.resolve(data);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    // find empresa (Autocomplete)
    findEmpresaByName = (name) => {
        let defer = this.$q.defer();
        this.CoreCliente.find({
            filter: {
                where: { nome: { like: `%${name}%` } },
                limit: 10
            }
        })
            .$promise.then(data => {
            const formattedData = (data || []).map((cliente) => ({
                id: cliente.id, // Assume que o ID está disponível como `id`
                name: cliente.nome // Assume que o nome está disponível como `nome`
            }));
            defer.resolve(formattedData);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    // find funcionário (Autocomplete)
    findFuncionarioByName = (name) => {
        let defer = this.$q.defer();
        this.Funcionario.find({
            filter: {
                where: { name: { like: `%${name}%` } },
                limit: 10
            }
        })
            .$promise.then(data => {
            const formattedData = (data || []).map((contacto) => ({
                id: contacto.id, // Assume que o ID está disponível como `id`
                name: contacto.name // Assume que o nome está disponível como `nome`
            }));
            defer.resolve(formattedData);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    // find contacto (Autocomplete com paginação)
    funcionarioAutocomplete = (name, page, limit, noFetch) => {
        let defer = this.$q.defer();
        this.Funcionario.find({
            filter: {
                where: {
                    and: [
                        { name: { like: `%${name}%` } },
                        { id: { nin: noFetch } }, // Não incluir IDs do noFetch
                        { active: 1 }
                    ]
                },
                skip: page * limit,
                limit: limit
            }
        })
            .$promise.then(data => {
            const formattedData = (data || []).map((f) => ({
                id: f.id,
                name: f.name,
                email: f.email,
                num: f.numeroMecanografico
            }));
            defer.resolve(formattedData);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    findEmpresaById = (id) => {
        let defer = this.$q.defer();
        this.CoreCliente.findOne({ filter: { where: { id: id } } })
            .$promise.then(data => {
            defer.resolve(data);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    // find contacto (Autocomplete com paginação)
    findContactoByName = (name, page, limit, noFetch) => {
        let defer = this.$q.defer();
        this.CoreContacto.find({
            filter: {
                where: {
                    and: [
                        { nome: { like: `%${name}%` } },
                        { id: { nin: noFetch } } // Não incluir IDs do noFetch
                    ]
                },
                include: ['cliente'],
                skip: page * limit,
                limit: limit
            }
        })
            .$promise.then(data => {
            const formattedData = (data || []).map((contacto) => ({
                id: contacto.id,
                name: contacto.nome,
                email: contacto.email || '',
                empresa: contacto.cliente?.nome || 'Sem empresa associada'
            }));
            defer.resolve(formattedData);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    // Pessoas Associadas
    getPessoasAssociadas = (id) => {
        let defer = this.$q.defer();
        this.CrmPessoaAssociada.find({
            filter: {
                where: { idCoreContacto: id, active: 1 },
                include: [
                    {
                        relation: 'contactoAssociado', // Relação definida no modelo CrmPessoaAssociada
                        scope: {
                            include: [
                                {
                                    relation: 'cliente' // Relação para buscar os dados do cliente
                                }
                            ]
                        }
                    }
                ]
            }
        })
            .$promise.then(data => {
            defer.resolve(data);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    alterarAssociacao = (idContacto, idNovaEmpresa) => {
        let defer = this.$q.defer();
        this.CoreContacto.patch({ id: idContacto }, { clienteId: idNovaEmpresa })
            .$promise.then(data => {
            defer.resolve(data);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    removePessoasAssociadas = (ids) => {
        let defer = this.$q.defer();
        // Lista de promessas para atualizar o campo 'active' para 0
        const updatePromises = ids.map(id => this.CrmPessoaAssociada.patch({ id }, { active: 0 }).$promise);
        Promise.all(updatePromises)
            .then(() => {
            defer.resolve();
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    // tabela empresas
    findAllClientes(query) {
        return this.CoreCliente.table(query).$promise;
    }
    optionsClientes() {
        return this.CoreCliente.options().$promise;
    }
    // tabela clientes
    findAllContactos(query, client) {
        if (client) {
            query.filter = query.filter || {};
            query.filter['clienteId'] = `$raw:((\`core_contacto\`.cliente_id = ${client}))`;
        }
        return this.CoreContacto.table(query).$promise;
    }
    optionsContactos() {
        return this.CoreContacto.options().$promise;
    }
    // tabela interacoes
    findAllInteracoes(query) {
        return this.CrmInteracao.table(query).$promise;
    }
    optionsInteracoes() {
        return this.CrmInteracao.options().$promise;
    }
    // tabela documentos associados
    findAllDocumentosAssociados(query) {
        return this.CrmDocumentoAssociado.table(query).$promise;
    }
    optionsDocumentosAssociados() {
        return this.CrmDocumentoAssociado.options().$promise;
    }
    // tabela pessoas associados
    findAllPessoasAssociada(query) {
        return this.CrmPessoaAssociada.table(query).$promise;
    }
    optionsPessoasAssociada() {
        return this.CrmPessoaAssociada.options().$promise;
    }
    // tabela cotações
    findAllCotacoes(query) {
        return this.CrmCotacao.table(query).$promise;
    }
    optionsCotacoes() {
        return this.CrmCotacao.options().$promise;
    }
    exportCotacoes(query) {
        return this.CrmCotacao.export(query).$promise;
    }
    // tabela cotações
    findAllOportunidades(query) {
        return this.CrmOportunidade.table(query).$promise;
    }
    optionsOportunidades() {
        return this.CrmOportunidade.options().$promise;
    }
    // tabela vendedores
    findAllVendedores(query) {
        return this.CrmVendedor.table(query).$promise;
    }
    optionsVendedores() {
        return this.CrmVendedor.options().$promise;
    }
    // tabela OI's do cliente
    findAllOi(query) {
        return this.CoreClienteOi.table(query).$promise;
    }
    optionsOi() {
        return this.CoreClienteOi.options().$promise;
    }
    // tabela processos do cliente
    findAllProcessos(query) {
        return this.CoreClienteProcesso.table(query).$promise;
    }
    optionsProcessos() {
        return this.CoreClienteProcesso.options().$promise;
    }
    // tabela propostas
    findAllPropostas(query) {
        return this.CrmProposta.table(query).$promise;
    }
    // tabela propostas com a ultima data criada do proxima interaçao
    findAllPropostasWitNextInteraction(query) {
        return this.CrmProposta.tableWitNextInteraction(query).$promise;
    }
    optionsPropostas() {
        return this.CrmProposta.options().$promise;
    }
    exportPropostas(query) {
        return this.CrmProposta.export(query).$promise;
    }
    getEstadosCotacao = () => {
        return this.CrmCotacaoEstado.find({
            filter: {
                where: {
                    active: true
                }
            }
        }).$promise;
    };
    // contactos associados ao cliente (pessoas associadas à empresa x)
    getContactosAssociados = (clientId) => {
        return this.CoreContacto.find({
            filter: {
                where: {
                    and: [{ clienteId: clientId }, { active: 1 }]
                }
            }
        }).$promise;
    };
    // Linhas de cotação -> retorn o total da cotação
    upsertLinhaCotacao = (linha, remove, cotacao, hist) => {
        return this.CrmLinhaCotacao.updateLinha({ params: { linha, remove, cotacao, hist } }).$promise;
    };
    getCotacaoById = (id) => {
        let defer = this.$q.defer();
        this.CrmCotacao.findOne({ filter: { where: { id: id } } })
            .$promise.then(data => {
            defer.resolve(data);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    getContactoById = async (contactoId) => {
        try {
            const result = await this.CoreContacto.find({
                filter: {
                    where: {
                        and: [{ id: contactoId }, { active: 1 }]
                    },
                    fields: { nome: true }
                }
            }).$promise;
            return result?.length > 0 ? result[0].nome : null;
        }
        catch (error) {
            console.error('Erro ao buscar contacto:', error);
            return null;
        }
    };
    getNomes = async (ids) => {
        const promises = ids.map(id => this.Funcionario.find({
            filter: {
                where: { and: [{ id: id }, { active: 1 }] },
                fields: { name: true }
            }
        }).$promise.then((result) => ({
            id,
            nome: result.length > 0 ? result[0].name : null
        })));
        return Promise.all(promises);
    };
    getDepartamentos = () => {
        return this.CoreDepartamento.find({
            filter: {
                where: {
                    active: true
                }
            }
        }).$promise;
    };
    getAlteracoesById = (id) => {
        return this.CrmAlteracaoestadoCotacao.find({
            filter: {
                where: {
                    and: [{ cotacaoId: id }, { active: 1 }]
                },
                include: 'Funcionario'
            }
        }).$promise;
    };
    updateOportunidade = async (op) => {
        let defer = this.$q.defer();
        if (op.Cliente) {
            delete op.Cliente;
        }
        if (op.ColaboradorOrigem) {
            delete op.ColaboradorOrigem;
        }
        if (op.Departamento) {
            delete op.Departamento;
        }
        this.CrmOportunidade.upsert(op)
            .$promise.then(data => {
            defer.resolve(data);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    saveCotacao = async (cotacao, documentos, alteracoes) => {
        let defer = this.$q.defer();
        // console.log(files);
        // Não pode enviar files no params porque é um JSON
        this.CrmCotacao.saveCotacao({ params: { cotacao, documentos, alteracoes } })
            .$promise.then(data => {
            defer.resolve(data);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    updateCotacao = async (cotacao) => {
        let defer = this.$q.defer();
        this.CrmCotacao.upsert(cotacao)
            .$promise.then(data => {
            defer.resolve(data);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    // tabela pessoas associados
    findAllLinhasCotacao(query) {
        return this.CrmLinhaCotacao.table(query).$promise;
    }
    optionsLinhasCotacao() {
        return this.CrmLinhaCotacao.options().$promise;
    }
    createVendedor = async (idFunc) => {
        let defer = this.$q.defer();
        let newVendedor = {
            id: 0,
            funcionarioId: idFunc,
            registadoPor: 0,
            dataRegisto: moment().format()
        };
        this.CrmVendedor.createVendedor({ params: { newVendedor, idFunc } })
            .$promise.then(data => {
            defer.resolve(data);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    // Get funcionario -> se receber id a null retorna o funcionario logado
    findFuncionarioById = (id) => {
        let defer = this.$q.defer();
        this.Funcionario.findOne({ filter: { where: { id: !id ? this.getUserId() : id } } })
            .$promise.then(data => {
            defer.resolve(data);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    getIdVendedores = () => {
        return this.CrmVendedor.find({
            filter: {
                fields: { funcionarioId: true }
            }
        }).$promise.then((data) => {
            return data.map(vendedor => vendedor.funcionarioId);
        });
    };
    findVendedorById = (id) => {
        let defer = this.$q.defer();
        this.CrmVendedor.findOne({ filter: { where: { id: id }, include: 'Funcionario' } })
            .$promise.then(data => {
            defer.resolve(data);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    updateVendedor = async (v) => {
        try {
            const updatedVendedor = await this.CrmVendedor.patch({ id: v.id }, { imagem: v.imagem }).$promise;
            return updatedVendedor;
        }
        catch (error) {
            console.error('Erro ao atualizar a imagem do Vendedor:', error);
            throw error;
        }
    };
    updateFuncionario = async (funcionario) => {
        try {
            const updatedFuncionario = await this.Funcionario.patch({ id: funcionario.id }, { telemovel: funcionario.contacto }).$promise;
            return updatedFuncionario;
        }
        catch (error) {
            console.error('Erro ao atualizar o contacto do Colaborador:', error);
            throw error;
        }
    };
    getPriClienteByNif = (nif) => {
        let defer = this.$q.defer();
        this.PRIClientes.find({ filter: { where: { numcontrib: nif } } })
            .$promise.then(data => {
            defer.resolve(data);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    getCondicoesPagamento = (id) => {
        let defer = this.$q.defer();
        this.PRIIEPCondpag.find({
            filter: {
                where: { condpag: id },
                fields: { descricao: true }
            }
        })
            .$promise.then(data => {
            defer.resolve(data);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    // Verificar se cliente existe (antes de adicionar)
    checkCliente = async (nif) => {
        try {
            const data = await this.CoreCliente.findOne({ filter: { where: { nif: nif } } }).$promise;
            return data !== null && data !== undefined; // Retorna true se encontrar o cliente
        }
        catch (error) {
            if (error.status === 404) {
                return false; // Cliente não encontrado, retorna false sem erro
            }
            console.log('Erro ao verificar cliente:', error);
            return false; // Retorna false em caso de erro inesperado
        }
    };
    addCoreCliente = async (cli) => {
        let defer = this.$q.defer();
        cli.uuid = v4();
        cli.criadoPorId = this.getUserId();
        cli.dataCriacao = moment().format();
        this.CoreCliente.create(cli)
            .$promise.then(data => {
            defer.resolve(data);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    syncCliente = async (ref) => {
        let defer = this.$q.defer();
        this.PRIClientes.findOne({ filter: { where: { cliente: ref } } })
            .$promise.then(data => {
            defer.resolve(data);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    syncContacto = async (ref) => {
        let defer = this.$q.defer();
        this.PRIIEPContactos.findOne({ filter: { where: { contacto: ref } } })
            .$promise.then(data => {
            defer.resolve(data);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    // Verificar se contacto existe (antes de adicionar)
    checkContacto = async (cp) => {
        try {
            const data = await this.CoreContacto.findOne({ filter: { where: { refContactoPrimavera: cp } } }).$promise;
            return data !== null && data !== undefined; // Retorna true se encontrar o contacto
        }
        catch (error) {
            if (error.status === 404) {
                return false; // contacto não encontrado, retorna false sem erro
            }
            console.log('Erro ao verificar cliente:', error);
            return false; // Retorna false em caso de erro inesperado
        }
    };
    getPriContactoByCP = (cp) => {
        let defer = this.$q.defer();
        this.PRIIEPContactos.find({ filter: { where: { contacto: cp } } })
            .$promise.then(data => {
            defer.resolve(data);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    addClienteAndContactos = (cliente, contactos) => {
        let defer = this.$q.defer();
        contactos.forEach(c => (c.password = v4()));
        cliente.uuid = v4();
        this.CoreCliente.createClienteAndContactos({ params: { cliente, contactos } })
            .$promise.then(data => {
            defer.resolve(data);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    getContactosAssociadosPrimavera = async (ref) => {
        try {
            const contactosAssociados = await this.PRIIEPLinhascontactoentidades.find({
                filter: {
                    where: { entidade: ref },
                    fields: { idcontacto: true, email: true }
                }
            }).$promise;
            if (!contactosAssociados || contactosAssociados.length === 0) {
                return [];
            }
            else {
                let x = await this.getPriContactosById(contactosAssociados);
                return x.flat();
            }
        }
        catch (error) {
            console.error('Erro ao obter contactos associados do Primavera:', error);
            return [];
        }
    };
    reSyncClient = async (ref) => {
        try {
            let x = await this.CoreCliente.reSyncClient({ params: { ref } }).$promise;
            return x.arrayContactos;
        }
        catch (error) {
            console.error('Erro ao sincornizar', error);
            return [];
        }
    };
    registarContactos = async (contactos, empresa) => {
        try {
            await this.CoreContacto.registarContactos({ params: { contactos, empresa } }).$promise;
        }
        catch (error) {
            console.error('Erro ao registar Contactos', error);
        }
    };
    getPriContactosById = async (cp) => {
        const arrayContactos = [];
        let contactoExistente;
        for await (let c of cp) {
            try {
                const contacto = await this.PRIIEPContactos.findOne({
                    filter: { where: { id: c.idcontacto } }
                }).$promise;
                if (c.email != contacto.email && c.email != null) {
                    contacto.email = c.email;
                }
                if (contacto.email) {
                    /// validar email
                    if (this.validEmail(contacto.email)) {
                        /// Verificar se email já existe
                        try {
                            contactoExistente = await this.CoreContacto.findOne({
                                filter: {
                                    where: {
                                        and: [{ email: contacto.email }, { active: 1 }]
                                    }
                                }
                            }).$promise;
                        }
                        catch (error) {
                            console.log('Contacto não encontrado: ', error);
                        }
                        if (!contactoExistente) {
                            arrayContactos.push(contacto);
                        }
                    }
                }
            }
            catch (error) {
                console.error('Erro ao obter contacto por ID:', error);
                return [];
            }
        }
        return arrayContactos;
    };
    getContactosAssociadosEmpresa = (id) => {
        return this.CoreContacto.find({
            filter: {
                where: {
                    and: [{ clienteId: id }, { active: 1 }]
                },
                fields: { id: true, nome: true, email: true, refContactoPrimavera: true }
            }
        }).$promise;
    };
    cotacaoAutocomplete = (search, page) => {
        const defer = this.$q.defer();
        this.CrmCotacao.find({
            filter: {
                where: {
                    and: [
                        {
                            or: [{ numeroCotacao: { like: `%${search}%` } }, { titulo: { like: `%${search}%` } }]
                        },
                        { active: 1 }
                    ]
                },
                skip: page * 10,
                limit: 10,
                fields: { id: true, numeroCotacao: true, titulo: true, clienteId: true }
            }
        })
            .$promise.then(data => defer.resolve(data))
            .catch(error => defer.reject(error));
        return defer.promise;
    };
    getNomeCliente = (id) => {
        const defer = this.$q.defer();
        this.CoreCliente.findOne({
            filter: {
                where: {
                    and: [{ id: id }]
                },
                fields: { nome: true }
            }
        })
            .$promise.then(data => defer.resolve(data?.nome || null))
            .catch(error => defer.reject(error));
        return defer.promise;
    };
    /// GRÁFICOS
    getPropostasEmitidas = (ref) => {
        let defer = this.$q.defer();
        this.PRICabecdoc.find({ filter: { where: { entidade: ref, tipodoc: 'PR' }, fields: { data: true, entidade: true, tipodoc: true, totalmerc: true } } })
            .$promise.then(data => {
            defer.resolve(data);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    // TipoDoc PR e estado em apreciação
    getPropostasEmAberto = (ref) => {
        let defer = this.$q.defer();
        this.PRICabecdoc.find({ filter: { where: { entidade: ref, tipodoc: 'PR', cduEstado: 'Em Apreciação' }, fields: { data: true, entidade: true, tipodoc: true, totalmerc: true, cduEstado: true } } })
            .$promise.then(data => {
            defer.resolve(data);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    // TotalMerc de todos os TipoDoc (FA, FAR, NC)
    getVolumeFaturado = (ref) => {
        let defer = this.$q.defer();
        this.PRICabecdoc.find({ filter: { where: { entidade: ref, tipodoc: { inq: ['FA', 'FAR', 'NC'] } }, fields: { data: true, entidade: true, tipodoc: true, totalmerc: true } } })
            .$promise.then(data => {
            defer.resolve(data);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    // Pedidos de cotação em aberto (estados -> em cotação (30), em edição dep. externo (50), concluído (70))
    getPCA = (id) => {
        let defer = this.$q.defer();
        this.CrmCotacao.find({ filter: { where: { clienteId: id, estadoId: { inq: [30, 50, 70] } }, fields: { dataAbertura: true, estadoId: true, clienteId: true } } })
            .$promise.then(data => {
            defer.resolve(data);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    /// GRÁFICOS
    getPropostasEmitidasVendedor = async (refVendedor) => {
        try {
            const today = new Date();
            const lastYear = new Date();
            lastYear.setFullYear(today.getFullYear() - 1); // Define a data como exatamente 12 meses atrás
            const lastYearStr = lastYear.toISOString();
            const propostas = await this.PRICabecdoc.find({
                filter: {
                    where: {
                        responsavel: refVendedor,
                        tipodoc: 'PR',
                        and: [{ data: { gt: lastYearStr } }] // Usa `and` para evitar operadores não suportados
                    },
                    fields: { data: true, entidade: true, tipodoc: true, totalmerc: true },
                    order: ['data DESC']
                }
            }).$promise;
            return propostas;
        }
        catch (error) {
            console.error('Erro ao obter propostas emitidas pelo vendedor:', error);
            return [];
        }
    };
    // TipoDoc PR e estado em apreciação
    getPropostasEmAbertoVendedor = (refVendedor) => {
        let defer = this.$q.defer();
        this.PRICabecdoc.find({ filter: { where: { responsavel: refVendedor, tipodoc: 'PR', cduEstado: 'Em Apreciação' }, fields: { data: true, entidade: true, tipodoc: true, totalmerc: true, cduEstado: true } } })
            .$promise.then(data => {
            defer.resolve(data);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    // TotalMerc de todos os TipoDoc (FA, FAR, NC)
    getVolumeFaturadoVendedor = (refVendedor) => {
        let defer = this.$q.defer();
        this.PRICabecdoc.find({ filter: { where: { responsavel: refVendedor, tipodoc: { inq: ['FA', 'FAR', 'NC'] } }, fields: { data: true, entidade: true, tipodoc: true, totalmerc: true } } })
            .$promise.then(data => {
            defer.resolve(data);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    getPCAVendedor = (id) => {
        let defer = this.$q.defer();
        this.CrmCotacao.find({ filter: { where: { funcionarioId: id, estadoId: { inq: [30, 50, 70] } }, fields: { dataAbertura: true, estadoId: true, clienteId: true } } })
            .$promise.then(data => {
            defer.resolve(data);
        })
            .catch(error => {
            defer.reject(error);
        });
        return defer.promise;
    };
    getMotivosCancelamento = () => {
        return this.CrmCotacaoCancelamento.find({ filter: { where: { active: 1 } } }).$promise;
    };
    getPropostaPrimavera = (nomeProposta, idCliente) => {
        return this.CrmProposta.importProposta({ params: { nomeProposta, idCliente } })
            .$promise.then(data => {
            return data; // Se não houver dados, retorna null explicitamente
        })
            .catch(error => {
            console.error('Erro ao obter proposta: ', error);
            throw error; // Repassa o erro para ser tratado na chamada
        });
    };
    getPropostasPrimaveraByCL = (cl) => {
        return this.CrmProposta.importPropostasByCl({ params: { cl } })
            .$promise.then(data => {
            return data; // Se não houver dados, retorna null explicitamente
        })
            .catch(error => {
            console.error('Erro ao obter proposta: ', error);
            throw error; // Repassa o erro para ser tratado na chamada
        });
    };
    /** Após refactor 16/03 */
    getProposta = (id) => {
        return this.CrmProposta.findOne({
            filter: {
                where: {
                    id: id
                },
                include: ['CoreCliente', 'CoreContacto']
            }
        }).$promise;
    };
    getLinhasProposta = (documento) => {
        return this.PRICabecdoc.findOne({
            filter: {
                where: {
                    documento
                },
                include: [
                    'estado',
                    {
                        relation: 'linhas',
                        scope: {
                            include: [
                                'estado',
                                {
                                    relation: 'transformacao',
                                    scope: {
                                        include: {
                                            relation: 'linha',
                                            scope: {
                                                include: 'cabecDoc'
                                            }
                                        }
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }).$promise;
    };
    getInteracoesForProposta = (id) => {
        return this.CrmInteracao.find({
            filter: {
                where: {
                    active: 1,
                    propostaId: id
                },
                include: ['Funcionario', 'CoreContacto']
            }
        }).$promise;
    };
    lookupProposta = (search, id) => {
        return this.CrmProposta.lookup({
            string: search,
            id: id
        }).$promise;
    };
    lookupCliente = (search) => {
        return this.CoreCliente.find({
            filter: {
                where: {
                    nome: {
                        like: `%${search}%`
                    }
                }
            }
        }).$promise;
    };
    lookupContacto = (search) => {
        return this.CoreContacto.find({
            filter: {
                where: {
                    nome: {
                        like: `%${search}%`
                    }
                }
            }
        }).$promise;
    };
    importProposta = (documento, clienteId, contactoId, cotacaoId) => {
        return this.CrmProposta.fromPrimavera({
            documento,
            clienteId,
            contactoId,
            cotacaoId
        }).$promise;
    };
    allFromPrimaveraForClient = (clienteId, contactoId, cotacaoId) => {
        return this.CrmProposta.allFromPrimaveraForClient({
            clienteId,
            contactoId,
            cotacaoId
        }).$promise;
    };
    getContactosForCliente = async (id) => {
        return this.CoreContacto.find({
            filter: {
                where: {
                    clienteId: id,
                    active: 1
                }
            }
        }).$promise;
    };
    createInteracao = (data) => {
        const userId = this.AuthenticationService.getId();
        return this.CrmInteracao.create({
            id: 0,
            funcionarioId: userId,
            ...data,
            active: 1
        }).$promise;
    };
    patchProposta = async (id, data) => {
        return this.CrmProposta.patch({
            id: id
        }, data).$promise;
    };
    patchContacto = async (id, data) => {
        return this.CoreContacto.patch({
            id: id
        }, data).$promise;
    };
    patchCotacao = async (id, data) => {
        return this.CrmCotacao.patch({
            id: id
        }, data).$promise;
    };
    adjudicaCotacao = (id, documento) => {
        return this.CrmCotacao.adjudica({
            id: id,
            documento: documento
        }).$promise;
    };
    uploadFile(main, folder, file) {
        const formData = new FormData();
        formData.append('file', file);
        return this.$http.post(`/api/${main}/${folder}/upload`, formData, {
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined }
        });
    }
    isValidNIF = (nif) => {
        if (!nif || !/^\d{9}$/.test(nif))
            return false;
        const validStarts = ['1', '2', '3', '5', '6', '8', '9'];
        if (!validStarts.includes(nif[0]))
            return false;
        let total = 0;
        for (let i = 0; i < 8; i++) {
            total += parseInt(nif[i]) * (9 - i);
        }
        const modulo = total % 11;
        const checkDigit = modulo < 2 ? 0 : 11 - modulo;
        return checkDigit === parseInt(nif[8]);
    };
    existsInContacto = (property, value) => {
        let test = {};
        test[property] = value;
        return this.CoreContacto.count({ where: test }).$promise;
    };
    existsContactoInCliente = (contacto, cliente) => {
        let test = {};
        test['clienteId'] = cliente;
        test['contactoId'] = contacto;
        return this.CoreClienteContacto.count({ where: test }).$promise;
    };
    existsInContactoAssociado = (associado, contacto) => {
        let test = {};
        test['idCoreContactoAssociado'] = associado;
        test['idCoreContacto'] = contacto;
        return this.CrmPessoaAssociada.count({ where: test }).$promise;
    };
    createContato = (data) => {
        const userId = this.AuthenticationService.getId();
        return this.CoreContacto.create({
            id: 0,
            active: 1,
            dataCriacao: moment().format(),
            criadoPorId: userId,
            ...data
        }).$promise;
    };
    createContactoCliente = (data) => {
        return this.CoreClienteContacto.create({
            id: 0,
            active: 1,
            ...data
        }).$promise;
    };
    createAssociacaoContacto = (data) => {
        return this.CrmPessoaAssociada.create({
            id: 0,
            active: 1,
            ...data
        }).$promise;
    };
    patchContactoCliente = async (id, data) => {
        return this.CoreClienteContacto.patch({
            id: id
        }, data).$promise;
    };
    // tabela empresas associadas
    findAllEmpresaAssociada(query) {
        return this.CoreClienteContacto.table(query).$promise;
    }
    optionsEmpresaAssociada() {
        return this.CoreClienteContacto.options().$promise;
    }
    findAllContactosAssociados(query) {
        return this.CrmPessoaAssociada.table(query).$promise;
    }
    syncClienteOis = (id) => {
        return this.CoreCliente.syncClienteOis({ id }).$promise;
    };
    syncAllOis = () => {
        let defer = this.$q.defer();
        this.$http
            .post(`/api/CoreClientes/sync-ois-all`, {})
            .then((res) => {
            defer.resolve(res.data);
        })
            .catch((error) => {
            defer.reject(error);
        });
        return defer.promise;
    };
}
CrmService.$inject = [
    '$rootScope',
    '$q',
    '$http',
    'AuthenticationService',
    'CoreCliente',
    'CoreContacto',
    'CoreClienteContacto',
    'CrmInteracao',
    'Funcionario',
    'CrmEmpresaAssociada',
    'CrmDocumentoAssociado',
    'CrmPessoaAssociada',
    'CrmCotacao',
    'CrmCotacaoEstado',
    'CrmLinhaCotacao',
    'CoreDepartamento',
    'CrmAlteracaoestadoCotacao',
    'CrmOportunidade',
    'CrmVendedor',
    'CoreClienteOi',
    'CoreClienteProcesso',
    'PRIClientes',
    'PRIIEPContactos',
    'PRIIEPLinhascontactoentidades',
    'PRIIEPCondpag',
    'PRICabecdoc',
    'PRILinhasdoc',
    'CrmProposta',
    'CrmCotacaoCancelamento'
];
